// SP nav
$(document).ready(function(){
  $('.js-nav-bt').on('click', function () {
    if ($('.js-nav-content').hasClass('is-navOn')) {
      $(".js-nav-content, .header").removeClass('is-navOn');
      $(this).removeClass('is-navOn');
    } else {
      $(".js-nav-content, .header").addClass('is-navOn');
      $(this).addClass('is-navOn');
    }
  });
  $('.js-nav-bt.is-navOn, .js-nav-link').on('click', function () {
    $(".js-nav-content.is-navOn, .js-nav-bt.is-navOn, .header.is-navOn").removeClass('is-navOn');
    $(".js-nav-content.is-navOn, .js-nav-bt.is-navOn, .header.is-navOn").removeClass('is-navOn');
  });
});

// // smooth scroll
$(function () {
  const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
  for (let i = 0; i < smoothScrollTrigger.length; i++){
    smoothScrollTrigger[i].addEventListener('click', (e) => {
      e.preventDefault();
      let href = smoothScrollTrigger[i].getAttribute('href');
      let targetElement = document.getElementById(href.replace('#', ''));
      const rect = targetElement.getBoundingClientRect().top;
      const offset = window.pageYOffset;
      const gap = 0;
      const target = rect + offset - gap;
      window.scrollTo({
        top: target,
        behavior: 'smooth',
      });
    });
  }
});
